import { render } from "./clientTable.vue?vue&type=template&id=394c15d6&scoped=true"
import script from "./clientTable.vue?vue&type=script&lang=js"
export * from "./clientTable.vue?vue&type=script&lang=js"

import "./clientTable.vue?vue&type=style&index=0&id=394c15d6&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-394c15d6"]])

export default __exports__